import { render, staticRenderFns } from "./studentDashbord.vue?vue&type=template&id=0f6cd60a&"
import script from "./studentDashbord.vue?vue&type=script&lang=js&"
export * from "./studentDashbord.vue?vue&type=script&lang=js&"
import style0 from "./studentDashbord.vue?vue&type=style&index=0&id=0f6cd60a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports